import { Col, Row } from "antd";
import React from "react";
import ThemedText from "../../../components/ThemedText/ThemedText";
import { BestSection, recommendSection } from "../../../data/Data";
import ThemedButton from "../../../components/Button/Button";
import { centerDiv } from "../../../styles/Format";
import { useMediaQuery } from "react-responsive";

export default function Recommend() {
  const isMobile = useMediaQuery({ maxWidth: 767 });

  return (
    <div style={{ marginTop: "10vh", marginBottom: "10vh" }}>
      {!isMobile && (
        <Row className="container">
          <Col span={24} md={12}>
            <ThemedText style={{ fontSize: "3rem", fontWeight: "bold" }}>
              {recommendSection.name}
            </ThemedText>
          </Col>
          <Col span={24} md={12}>
            <ThemedText>{recommendSection.text2}</ThemedText>
            <br />
            <ThemedText>{recommendSection.text2x}</ThemedText>
          </Col>
        </Row>
      )}

      <div>
        {isMobile && (
          <div className="container" align="left">
            <>
              <ThemedText style={{ fontSize: "2rem", fontWeight: "bold" }}>
                {recommendSection.name}
              </ThemedText>
              <br />
              <ThemedText>
                {recommendSection.text2 + recommendSection.text2x}
              </ThemedText>
            </>
          </div>
        )}
      </div>

      <br />

      <div className="container">
        <Row gutter={[16, 16]}>
          {recommendSection.array.map((item) => (
            <Col
              span={24}
              sm={6}
              md={6}
              lg={6}
              key={item.title}
              style={{ position: "relative" }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  alignItems: "center",
                  height: isMobile ? "30vh" : "40vh",
                  borderRadius: 20,
                  backgroundImage: `url(${item.bg})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  padding: 20,
                  margin: "20px 0",
                  position: "relative",
                  // textAlign: "center", // Center-align text horizontally
                }}
              >
                <img src={item.bg} />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "bottom",
                    flexGrow: 1,
                    // background: "green",
                    justifyContent: "center",
                  }}
                >
                  <div
                    style={{
                      color: "white",
                      fontWeight: "bold",
                      marginBottom: 10,
                    }}
                  >
                    {item.title}
                  </div>
                  <div style={{ color: "white" }}>{item.description}</div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
}
